import { render, staticRenderFns } from "./all-compliance.vue?vue&type=template&id=94cfefb6&scoped=true&"
import script from "./all-compliance.vue?vue&type=script&lang=js&"
export * from "./all-compliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cfefb6",
  null
  
)

export default component.exports